var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"eyebrow-icon",class:[_vm.eyebrowicon.icon, _vm.eyebrowicon.color, _vm.align],on:{"click":function($event){$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }